export const APP_STATE_PATH = "app";
